import { useSyncExternalStore } from 'react';

/**
 * The phone breakpoint is the one layout decision the shell makes for every
 * screen: below 768 px the table is not rendered and the bottom bar appears
 * (docs/ux/shell.md). Column priorities use the width itself.
 */
const PHONE_MAX = 767;

function subscribe(cb: () => void) {
  window.addEventListener('resize', cb);
  return () => window.removeEventListener('resize', cb);
}

export function useViewportWidth(): number {
  return useSyncExternalStore(subscribe, () => window.innerWidth, () => 1536);
}

export function useIsPhone(): boolean {
  return useViewportWidth() <= PHONE_MAX;
}
